import CREATORS_MOCK_1 from '@/mocks/brand-safety/creators_v3.json';
import CREATORS_MOCK_2 from '@/mocks/brand-safety/creators_v4.json';
import CREATORS_MOCK_3 from '@/mocks/brand-safety/creators_v5.json';
import axiosWithAuth from '@/utils/axiosWithAuth';
import mapKeysToCase from '@/utils/mapKeysToCase';
import {CreatorSafetyReport} from '@/types/creatorSafetyReport';
import QueryContext from '../QueryContext';

const defaultCreatorId = '2';

const USE_MOCK = false;

const CREATORS_MOCK = {
  ...CREATORS_MOCK_1,
  ...CREATORS_MOCK_2,
  ...CREATORS_MOCK_3,
};

const vettingFetchers = {
  report: (
    context: QueryContext,
    {limitPerFlag}: {limitPerFlag?: number} = {}
  ) => {
    // TODO: remove this block and all mock related code
    if (USE_MOCK) {
      let creatorData = CREATORS_MOCK[defaultCreatorId];
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      creatorData = CREATORS_MOCK[context.meta?.creatorId] || creatorData;
      return mapKeysToCase(creatorData) as unknown as CreatorSafetyReport;
    }
    return axiosWithAuth.get(
      `/creators/${context.meta?.creatorId}/brands_safety_reports/${context.meta?.reportId}`,
      {
        params: {
          brand_id: context.meta?.brandId,
          ...(limitPerFlag ? {limit_per_flag: limitPerFlag} : {}),
          ...(context.meta?.scope ? {scope: context.meta.scope} : {}),
        },
      }
    );
  },

  latestReportId: (creatorId: string, brandId: string, scope?: string) =>
    axiosWithAuth.get<{reportId?: string}>(
      `/creators/${creatorId}/brands_safety_reports/latest_id`,
      {
        params: {
          brand_id: brandId,
          ...(scope ? {scope} : {}),
        },
      }
    ),

  embedding: (context: QueryContext) =>
    axiosWithAuth.get(`/social_networks/${context.meta?.provider}/embeddings`, {
      params: {
        url: context.meta?.url,
      },
    }),
  backgroundCheck: (context: QueryContext) =>
    axiosWithAuth.get(
      `/creators/${context.meta?.creatorId}/brands_safety_reports/${context.meta?.reportId}/enrich_background_check`,
      {
        params: {
          url: context.meta?.url,
        },
      }
    ),
};

export default vettingFetchers;
